import { create } from "zustand"
import type { AuthClaims } from "@domo/shared"
import type { AuthStatus } from "../types"

interface AuthStoreState {
    status: AuthStatus
    token: string | null
    claims: AuthClaims | null
    error: string | null
    set: (s: Partial<AuthStoreState>) => void
}

export const useAuthStore = create<AuthStoreState>((set) => ({
    status: "checking",
    token: null,
    claims: null,
    error: null,
    set: (s) => set(s),
}))
